import { getWindow } from '@sitecore-search/common';
import configBuilder from './config/configBuilder.js';
export const parseCustomerKey = (customerKey) => {
    if (customerKey) {
        const match = customerKey.match(/^(\d+)-(\d+)$/);
        if (match) {
            return [match[1], match[2]];
        }
    }
    return null;
};
let SDKConfig = {
    apiDomain: '',
    apiKey: '',
    clientId: '',
    connector: 'sitecore',
    customerKey: '',
    debug: false,
    domainHash: '',
    domainId: '',
    env: 'prod',
    eventUrl: '',
    orderCloudRegion: 'usWest',
    publicSuffix: false,
    searchUrl: '',
    tokenDomain: '',
    tokenUrl: '',
    trackConsent: true,
    useAccessToken: false,
    userId: null,
};
export const setConfig = (config) => {
    SDKConfig = configBuilder(SDKConfig, config);
};
export const getConfigProperty = (key) => {
    return SDKConfig[key];
};
export const getServiceConfig = () => {
    return SDKConfig;
};
export const setUserId = (userId) => {
    SDKConfig.userId = userId;
};
export const setTrackConsent = (value) => {
    SDKConfig.trackConsent = value;
};
/**
 * @description: gets the domain to be used to register SDK cookies.
 * if publicSuffix is false (default value) will return only the subdomain to have a cross
 * subdomain cookie.
 * Otherwise, with publicSuffix = true, the full domain will be gathered meaning that cross subdomain
 * cookies are not allowed in this case.
 * e.g:
 * public suffix false, domain = donatello-delta.vercel.app => vercel.app
 * public suffix true, domain = donatello-delta.vercel.app => donatello-delta.vercel.app
 * @return: string with the domain to be used.
 */
export const getDomainHost = () => {
    const currentWindow = getWindow({ location: { hostname: '' } });
    const { publicSuffix } = getServiceConfig();
    if (!publicSuffix) {
        return currentWindow.location.hostname.split('.').reverse().splice(0, 2).reverse().join('.');
    }
    return currentWindow.location.hostname;
};
